// extracted by mini-css-extract-plugin
export var postImageWrapper = "blogIndexTemplate-module--postImageWrapper--db7df";
export var postLink = "blogIndexTemplate-module--postLink--d578c";
export var withSidebar = "blogIndexTemplate-module--withSidebar--18bbd";